module.exports = __webpack_public_path__ + "img/perspectivity.ff879164.png";